export default function WhatsAppFloat() {
  const handleClick = () => {
    window.open('https://wa.me/919574577631', '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 w-14 h-14 bg-green-500 rounded-full shadow-lg hover:bg-green-600 transition-all transform hover:scale-110 flex items-center justify-center z-50 cursor-pointer"
      aria-label="Contact us on WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl text-white"></i>
    </button>
  );
}
